import { BuildingType } from '../buildings';
import administrationConfig from './administration';
import apartmentConfig from './apartment';
import factoryConfig, {factoryHeatingConfig, factoryProcessesConfig, factoryProductionConfig, factorySprinklerCenterConfig} from './factory';
import hospitalConfig from './hospital';
import houseConfig from './house';
import industryConfig, {
    industryLabConfig,
    industryProductionConfig,
    industryTestcenterConfig,
    industryWaterConfig,
    industrySprinklerCenterConfig,
    industryHeatingCenterConfig,
} from './industry';
import ksbCenterConfig from './ksb-center';
import ksbQuicklinksConfig from '../building-config/ksb-quicklinks';
import ksbTeamConfig from './ksb-team';
import schoolConfig from './school';
import skyscraperConfig, { skyscraperWaterUpperConfig, skyscraperWaterLowerConfig } from '../building-config/skyscraper';
import hotelConfig from './hotel';
import dataCenterConfig, { dataCenterCoolingAirConfig, dataCenterCoolingDirectConfig, dataCenterCoolingLiquidConfig } from '../building-config/data-center';

export const buildings = {
    [BuildingType.HOUSE]: houseConfig,
    [BuildingType.APARTMENT]: apartmentConfig,
    [BuildingType.HOSPITAL]: hospitalConfig,
    [BuildingType.DATA_CENTER]: dataCenterConfig,
    [BuildingType.DATA_CENTER_COOLING_AIR]: dataCenterCoolingAirConfig,
    [BuildingType.DATA_CENTER_COOLING_DIRECT]: dataCenterCoolingDirectConfig,
    [BuildingType.DATA_CENTER_COOLING_LIQUID]: dataCenterCoolingLiquidConfig,
    [BuildingType.SCHOOL]: schoolConfig,
    [BuildingType.ADMINISTRATION]: administrationConfig,
    [BuildingType.SKYSCRAPER]: skyscraperConfig,
    [BuildingType.SKYSCRAPER_WATER_UPPER]: skyscraperWaterUpperConfig,
    [BuildingType.SKYSCRAPER_WATER_LOWER]: skyscraperWaterLowerConfig,
    [BuildingType.INDUSTRY]: industryConfig,
    [BuildingType.INDUSTRY_WATER]: industryWaterConfig,
    [BuildingType.INDUSTRY_TESTCENTER]: industryTestcenterConfig,
    [BuildingType.INDUSTRY_PRODUCTION]: industryProductionConfig,
    [BuildingType.INDUSTRY_LAB]: industryLabConfig,
    [BuildingType.INDUSTRY_SPRINKLER_CENTER]: industrySprinklerCenterConfig,
    [BuildingType.INDUSTRY_HEATING]: industryHeatingCenterConfig,
    [BuildingType.FACTORY]: factoryConfig,
    [BuildingType.FACTORY_HEATING]: factoryHeatingConfig,
    [BuildingType.FACTORY_PRODUCTION]: factoryProductionConfig,
    [BuildingType.FACTORY_PROCESSES]: factoryProcessesConfig,
    [BuildingType.FACTORY_SPRINKLER_CENTER]: factorySprinklerCenterConfig,
    [BuildingType.KSB_CENTER]: ksbCenterConfig,
    [BuildingType.HOTEL]: hotelConfig,
    [BuildingType.KSB_TEAM]: ksbTeamConfig,
    [BuildingType.KSB_QUICKLINKS]: ksbQuicklinksConfig,
};
